module.exports = __webpack_public_path__ + "s/img/Play_M_3.6f737c12.jpg";